'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { TransactionHistoryFrame } from './components/TransactionHistoryFrame/TransactionHistoryFrame';
export const TransactionHistory = () => _jsx(TransactionHistoryFrame, {});
